import { colors } from '../styles/colors';

export type TShadowElevations =
  | 'xs'
  | 'sm'
  | 'md'
  | 'lg'
  | 'xl'
  | 'focus.error'
  | 'focus.primary';

const HEX_OPACITY_5 = '0D';
const HEX_OPACITY_10 = '1A';
const HEX_OPACITY_15 = '26';
const HEX_OPACITY_20 = '33';

export const SHADOW_COLOR = colors.greyScale[4];

export const shadows = {
  xs: `0px 1px 4px 0px ${SHADOW_COLOR + HEX_OPACITY_20}, 0px 0px 1px 0px ${
    SHADOW_COLOR + HEX_OPACITY_10
  }`,
  sm: `0px 3px 8px 0px ${SHADOW_COLOR + HEX_OPACITY_15}, 0px 0px 2px 0px ${
    SHADOW_COLOR + HEX_OPACITY_10
  }`,
  md: `0px 3px 16px 0px ${SHADOW_COLOR + HEX_OPACITY_15}, 0px 0px 4px 0px ${
    SHADOW_COLOR + HEX_OPACITY_5
  }`,
  lg: `0px 10px 24px 0px ${SHADOW_COLOR + HEX_OPACITY_15}, 0px 0px 8px 0px ${
    SHADOW_COLOR + HEX_OPACITY_5
  }`,
  xl: `0px 10px 24px 0px ${SHADOW_COLOR + HEX_OPACITY_15}, 0px 0px 8px 0px ${
    SHADOW_COLOR + HEX_OPACITY_5
  }`,
  focus: {
    primary: `0px 0px 5px 0px ${colors.primary}`,
    error: `0px 0px 5px 0px  ${colors.redScale[4]}`,
  },
};
